import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const ProjectsListTable = ({
  children,
  count,
  company,
  subcompany,
  permissions,
  handleToggle = () => {},
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'key', text: t('projects.fields.key') + ': ', type: 'h3' },
    { variable: 'name', text: t('projects.fields.name') + ': ' },
    { variable: 'amount', text: t('projects.fields.amount') + ': ' },
    {
      variable: 'active',
      text: t('projects.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.projects.update',
    togglePermission: 'acl.projects.toggle',
    editUrl: 'projects', //Url para editar empleado
    propsName: 'project', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };

  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('projects.fields.key')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('projects.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="amount"
            handleOrderChange={handleOrderChange}
          >
            {t('projects.fields.amount')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('projects.fields.active')}
          </Common.ThSortable>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(ProjectsListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/list/ProjectsListTable.js